import axios from 'axios'
import { backendUrl } from '@/helpers/backendUrl.js'
import vuecookie from 'vue-cookies'

const state = {
    registrationRequests: []
}

const getters = {
    getRegistrationRequestList: (state) => state.registrationRequests
}

const actions = {
    async getDropdownValues( context, data){
        return await axios.get(`${backendUrl()}/getDropdownValues`,
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            return response.data
        })
    },
    async getRegistrationRequests( context, data ) {
        await axios.get(`${backendUrl()}/getRegistrationRequests`,
        {
            params: { 
                page: data.page,
                per_page: data.per_page,
                date_from: data.date_from,
                date_to: data.date_to,
                name: data.name,
                search: data.search,
                country: data.country,
                status: data.status,
                requestId: data.requestId //NS-9598 SP
            },       
            headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
        })
        .then(response => {
            context.commit('setRegistrationRequestResults', response.data)
        })  
    },
    async getRegistrationRequestsFromSearchInput( context, data ) { //NS-9598 SP General search function added
        await axios.get(`${backendUrl()}/getRegistrationRequestsFromSearchInput`,
        {
            params: { 
                page: data.page,
                per_page: data.per_page,
                searchInput: data.searchInput,
            },       
            headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
        })
        .then(response => {
            context.commit('setRegistrationRequestResults', response.data)
        })  
    },    
    async updateRegistrationStatus( context, data ) {
        await axios.post(`${backendUrl()}/updateRegistrationStatus`,
        {
            registrationIds: data.registrationIds,
            status: data.status,
            currentUser: data.currentUser
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.dispatch('handleResponse', response, {root: true})
        })  
    }    
}

const mutations = {
    setRegistrationRequestResults: (state, registrationRequests) => (state.registrationRequests = registrationRequests),
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}